import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";

import ChartOnlineOffline from "./ChartOnlineOffline";
import MiniDataGrid from "./MiniDataGrid";
import ObjectDetails from "./ObjectDetails";

export default function MainGridDashboard() {
  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        <Grid size={{ xs: 12, lg: 3 }}>
          <Grid size={12}>
            <ChartOnlineOffline />
          </Grid>
          <Grid size={12} sx={{ marginTop: 2 }}>
            <MiniDataGrid />
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, lg: 8 }}>
          <ObjectDetails />
        </Grid>
      </Grid>
    </Box>
  );
}
